<template>
    <div class='p-d-flex p-jc-center p-p-4' style="background:#f9f9f9; border:1px solid #d9d9d9;">
        <div class="p-d-flex p-jc-start p-ai-center">
            <h5 class="p-my-0 p-ml-2 text-muted">{{message}}</h5>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MessageNoResults',
    props: {
        message : {
            type : String
        },
    },
}
</script>